module.exports = __webpack_public_path__ + "img/smg.ac456b9b.png";